module.exports = __webpack_public_path__ + "static/media/green_overlay_right.97bc5d24.svg";